"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
// Will maintain a loading state for a React state update
// Recommended to be used with state updates that freeze UI
var useLoaderStateUpdate = function useLoaderStateUpdate(defaultState) {
  var _useState = (0, _react.useState)(defaultState),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultState),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    intermediaryState = _useState4[0],
    setIntermediaryState = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isLoaderShowing = _useState6[0],
    setIsLoaderShowing = _useState6[1];
  var firstRender = (0, _react.useRef)(true);
  var persistIntermediaryState = (0, _react.useCallback)(function () {
    setState(intermediaryState);
  }, [intermediaryState]);
  var hideLoader = (0, _react.useCallback)(function () {
    setIsLoaderShowing(false);
  }, []);
  (0, _react.useEffect)(function () {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setIsLoaderShowing(true);
  }, [intermediaryState]);
  (0, _react.useEffect)(function () {
    var timeout = setTimeout(persistIntermediaryState);
    return function () {
      return clearTimeout(timeout);
    };
  }, [persistIntermediaryState]);
  return {
    state: state,
    isLoaderShowing: isLoaderShowing,
    setState: setIntermediaryState,
    hideLoader: hideLoader
  };
};
var _default = exports["default"] = useLoaderStateUpdate;